import axiosInstance from "../../../axiosInceptor";

export const removeRewardsFromBasket = (basketID: string, rewardid: string) => {
  try {
    const url = process.env.REACT_APP_OLO_API || '';
    return axiosInstance
      .delete(url + `/baskets/${basketID}/loyaltyrewards/${rewardid}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  } catch (error) {
    throw error;
  }
};
